// Module
var code = "<div class=\"option-select\"><div class=\"option\" ng-repeat=\"option in options\" ng-click=\"selectOption(option)\" ng-class=\"{active: ngModel === option.value}\"> {( option.label )}</div></div>";
// Exports
module.exports = code;